import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { decode, encode } from "base-64";
import { api } from "../../../utlis/provider/api.utlis";
import Loader from "../../../layouts/loader/Loader";
import ApiService from "../../../core/services/ApiService";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { routes } from "../../../utlis/provider/routes.utlis";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import StarImg from "../../../assets/user/images/star.svg";
import DollarImg from "../../../assets/user/images/dollar-circle.svg";
import BriefcaseImg from "../../../assets/user/images/briefcase.svg";
import HouseImg from "../../../assets/user/images/house.svg";
import HandshakeImg from "../../../assets/user/images/Handshake.svg";
import StarWhImg from "../../../assets/user/images/starwh.svg";
import moment from "moment/moment";

const ProviderDetail = () => {
  const navigate = useNavigate();
  const localData = useLocation();
  const id = localData.state?.id;
  const [details, setDetails] = useState();
  const [loading, setLoading] = useState(false);

  const getDetails = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log(response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setDetails(response.data.data);
    } else setDetails();
    setLoading(false);
  };

  const subscriptionAuth = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      if (!response.data.data.networkDirectoryAccess) {
        navigate(routes.subscriptionPlan);
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    subscriptionAuth(api.subscriptionAuth);
    getDetails(api.userDetail + `${decode(id)}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="carenetwork-section">
          <div className="care-title-header">
            <h2 className="heading-title text-capitalize">
              {details?.user_type_text ?? ""} Detail
            </h2>
            <div className="search-filter">
              <div className="row g-2">
                <div className="col-md-12">
                  <div className="form-group">
                    <Link
                      className="btn-bl wd100"
                      to=""
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="providerProfile-section">
                <div className="user-table-item">
                  <div className="row g-1 align-items-center">
                    <div className="col-md-7">
                      <div className="user-profile-item">
                        <div className="user-profile-media">
                          {details?.logo !== null &&
                          details?.logo !== "" &&
                          details?.logo !== undefined ? (
                            <img src={details?.logo} alt="" className="me-3" />
                          ) : details?.profile_image === null ||
                            details?.profile_image === "" ||
                            details?.profile_image === undefined ? (
                            <img src={NoImage} alt="" className="me-3" />
                          ) : (
                            <img
                              src={details?.profile_image}
                              alt=""
                              className="me-3"
                            />
                          )}
                        </div>
                        <div className="user-profile-text">
                          <h2>
                            {details?.business_name
                              ? details?.business_name
                              : details?.fullname}
                          </h2>
                          <div className="location-text">
                            {details?.business_address ?? "NA"}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="row g-1 align-items-center">
                        <div className="col-md-6">
                          <div className="user-contact-info">
                            <div className="user-contact-info-icon">
                              <img src={StarImg} />
                            </div>
                            <div className="user-contact-info-content">
                              <h2>Rating</h2>
                              <p>
                                {details?.avarageRating?.average_rating ??
                                  "0.0"}
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* <div className="col-md-4">
                          <div className="user-contact-info">
                            <div className="user-contact-info-icon">
                              <img src={DollarImg} />
                            </div>
                            <div className="user-contact-info-content">
                              <h2>Rate</h2>
                              <p>{details?.fee ?? "NA"}</p>
                            </div>
                          </div>
                        </div> */}

                        <div className="col-md-6">
                          <div className="user-contact-info">
                            <div className="user-contact-info-icon">
                              <img src={BriefcaseImg} />
                            </div>
                            <div className="user-contact-info-content">
                              <h2>Experience</h2>
                              <p>{details?.experience ?? 0} Years</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="providerProfile-point">
                    <div className="providerprofile-point-item">
                      <img src={HouseImg} /> Cared {details?.caredFamilys ?? 0}{" "}
                      Families
                    </div>
                    <div className="providerprofile-point-item">
                      <img src={HandshakeImg} /> Hired By{" "}
                      {details?.caredFamilyNearBy ?? 0} Families In Your
                      Neighbourhood
                    </div>
                  </div>
                </div>

                <div className="providerprofile-overview">
                  <div className="row g-2">
                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Repeat Clients</h2>
                          <h4>{details?.repeatClient ?? 0}</h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Response Rate</h2>
                          <h4>{details?.responseRate ?? "0%"}</h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Response Time</h2>
                          <h4>{details?.responseTime ?? "NA"}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="providerprofile-about">
                  <h2>About</h2>
                  <p>{details?.description ?? "NA"}</p>
                </div>

                <div className="providerprofile-about">
                  <h2>Offering Services</h2>
                  <div>
                    <div className="tags-item">{details?.category ?? "NA"}</div>
                    <div className="tags-item-sub">
                      {details?.subcategory ?? "NA"}
                    </div>
                  </div>
                </div>

                <div class="review-card mt-3">
                  <div class="review-card-content">
                    <div class="review-card-icon">
                      <img src={StarWhImg} />
                    </div>
                    <div class="review-card-text">
                      <h3>Rating & Review</h3>
                      <p>
                        {details?.avarageRating?.average_rating ?? 0}(
                        {details?.avarageRating?.total_reviews ?? 0})
                      </p>
                    </div>
                  </div>
                  {/* <div class="review-card-action">
                    <link to="">Write your Review</link>
                  </div> */}
                </div>
                <div class="care-comment-list">
                  {details?.reviewsList.length !== 0
                    ? details?.reviewsList.map((ele, indx) => {
                        return (
                          <div key={indx} class="care-comment-item">
                            <div class="care-comment-profile">
                              {ele?.image !== null &&
                              ele?.image !== "" &&
                              ele?.image !== undefined ? (
                                <img src={ele?.image} alt="" />
                              ) : (
                                <img src={NoImage} alt="" />
                              )}
                            </div>
                            <div class="care-comment-content">
                              <div class="care-comment-head">
                                <div class="">
                                  <h2>{ele?.fullname ?? "NA"}</h2>
                                  <div class="care-comment-rating">
                                    <i class="fa fa-star"></i>{" "}
                                    {ele?.rating ?? 0}
                                  </div>
                                </div>
                                <div class="care-date">
                                  <i class="fa fa-calendar"></i>{" "}
                                  {moment(ele?.modified_date).format(
                                    "MM-DD-yyyy hh:mm A"
                                  )}
                                </div>
                              </div>
                              <div class="care-comment-descr">
                                {ele?.review ?? "NA"}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProviderDetail;
